// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AmsPublicApiAccountsGetOwnAccountDetailData, AmsPublicApiAccountsGetOwnAccountDetailErrors, AmsPublicApiAccountsGetOwnAccountDetailResponses, AmsPublicApiAccountsRenameOwnAccountData, AmsPublicApiAccountsRenameOwnAccountErrors, AmsPublicApiAccountsRenameOwnAccountResponses, AmsPublicApiConfigGetAuthConfigData, AmsPublicApiConfigGetAuthConfigResponses, AmsPublicApiRolesCreateRoleData, AmsPublicApiRolesCreateRoleErrors, AmsPublicApiRolesCreateRoleResponses, AmsPublicApiRolesDeleteRoleData, AmsPublicApiRolesDeleteRoleErrors, AmsPublicApiRolesDeleteRoleResponses, AmsPublicApiRolesDuplicateRoleData, AmsPublicApiRolesDuplicateRoleErrors, AmsPublicApiRolesDuplicateRoleResponses, AmsPublicApiRolesGetPermissionTreeData, AmsPublicApiRolesGetPermissionTreeErrors, AmsPublicApiRolesGetPermissionTreeResponses, AmsPublicApiRolesListRolesData, AmsPublicApiRolesListRolesErrors, AmsPublicApiRolesListRolesResponses, AmsPublicApiRolesUpdateRoleData, AmsPublicApiRolesUpdateRoleErrors, AmsPublicApiRolesUpdateRoleResponses, AmsPublicApiTokensExchangeTokenData, AmsPublicApiTokensExchangeTokenErrors, AmsPublicApiTokensExchangeTokenResponses, AmsPublicApiUsersCreateUserData, AmsPublicApiUsersCreateUserErrors, AmsPublicApiUsersCreateUserResponses, AmsPublicApiUsersEditUserData, AmsPublicApiUsersEditUserErrors, AmsPublicApiUsersEditUserResponses, AmsPublicApiUsersGetUserData, AmsPublicApiUsersGetUserErrors, AmsPublicApiUsersGetUserResponses, AmsPublicApiUsersListUsersData, AmsPublicApiUsersListUsersErrors, AmsPublicApiUsersListUsersResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get Own Account Detail
 */
export const amsPublicApiAccountsGetOwnAccountDetail = <ThrowOnError extends boolean = false>(options?: Options<AmsPublicApiAccountsGetOwnAccountDetailData, ThrowOnError>): RequestResult<AmsPublicApiAccountsGetOwnAccountDetailResponses, AmsPublicApiAccountsGetOwnAccountDetailErrors, ThrowOnError> => (options?.client ?? client).get<AmsPublicApiAccountsGetOwnAccountDetailResponses, AmsPublicApiAccountsGetOwnAccountDetailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/account',
    ...options
});

/**
 * Rename Own Account
 */
export const amsPublicApiAccountsRenameOwnAccount = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiAccountsRenameOwnAccountData, ThrowOnError>): RequestResult<AmsPublicApiAccountsRenameOwnAccountResponses, AmsPublicApiAccountsRenameOwnAccountErrors, ThrowOnError> => (options.client ?? client).patch<AmsPublicApiAccountsRenameOwnAccountResponses, AmsPublicApiAccountsRenameOwnAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/account/name',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Auth Config
 */
export const amsPublicApiConfigGetAuthConfig = <ThrowOnError extends boolean = false>(options?: Options<AmsPublicApiConfigGetAuthConfigData, ThrowOnError>): RequestResult<AmsPublicApiConfigGetAuthConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AmsPublicApiConfigGetAuthConfigResponses, unknown, ThrowOnError>({ url: '/auth/config', ...options });

/**
 * Exchange Token
 */
export const amsPublicApiTokensExchangeToken = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiTokensExchangeTokenData, ThrowOnError>): RequestResult<AmsPublicApiTokensExchangeTokenResponses, AmsPublicApiTokensExchangeTokenErrors, ThrowOnError> => (options.client ?? client).post<AmsPublicApiTokensExchangeTokenResponses, AmsPublicApiTokensExchangeTokenErrors, ThrowOnError>({
    url: '/auth/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Permission Tree
 *
 * Return the grantable permission tree for the caller's own account.
 *
 * Gated by *any* role-management grant — the tree drives every role surface: the create and edit
 * forms render it as an editor, and the read-only standard-role view renders it disabled. Gating on
 * role.create alone would lock role.view/role.edit/role.delete holders (e.g. an Account Admin with
 * only role.view) out of the read-only view. Gating the read still prevents a principal with no
 * role-management capability from enumerating the account's entitlement structure; the tree is
 * already scoped to the account's feature packages.
 */
export const amsPublicApiRolesGetPermissionTree = <ThrowOnError extends boolean = false>(options?: Options<AmsPublicApiRolesGetPermissionTreeData, ThrowOnError>): RequestResult<AmsPublicApiRolesGetPermissionTreeResponses, AmsPublicApiRolesGetPermissionTreeErrors, ThrowOnError> => (options?.client ?? client).get<AmsPublicApiRolesGetPermissionTreeResponses, AmsPublicApiRolesGetPermissionTreeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/permissions',
    ...options
});

/**
 * List Roles
 *
 * List the roles in the caller's own account (for the role list and duplicate source-picker).
 *
 * Gated by *any* role-management grant — the list is the entry point to create/edit/delete, so a
 * holder of role.create/edit/delete (but not role.view) must still be able to load it.
 */
export const amsPublicApiRolesListRoles = <ThrowOnError extends boolean = false>(options?: Options<AmsPublicApiRolesListRolesData, ThrowOnError>): RequestResult<AmsPublicApiRolesListRolesResponses, AmsPublicApiRolesListRolesErrors, ThrowOnError> => (options?.client ?? client).get<AmsPublicApiRolesListRolesResponses, AmsPublicApiRolesListRolesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/roles',
    ...options
});

/**
 * Create Role
 *
 * Create a custom role in the caller's own account.
 */
export const amsPublicApiRolesCreateRole = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiRolesCreateRoleData, ThrowOnError>): RequestResult<AmsPublicApiRolesCreateRoleResponses, AmsPublicApiRolesCreateRoleErrors, ThrowOnError> => (options.client ?? client).post<AmsPublicApiRolesCreateRoleResponses, AmsPublicApiRolesCreateRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Duplicate Role
 *
 * Create a custom role in the caller's own account, pre-populated from an existing role.
 */
export const amsPublicApiRolesDuplicateRole = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiRolesDuplicateRoleData, ThrowOnError>): RequestResult<AmsPublicApiRolesDuplicateRoleResponses, AmsPublicApiRolesDuplicateRoleErrors, ThrowOnError> => (options.client ?? client).post<AmsPublicApiRolesDuplicateRoleResponses, AmsPublicApiRolesDuplicateRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/roles/duplicate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Role
 *
 * Delete a custom role in the caller's own account.
 *
 * Same 404-for-both disclosure contract as update_role. Standard and owner roles are immutable (409);
 * a role still assigned to users returns 409 (role_in_use) so the admin reassigns them first.
 */
export const amsPublicApiRolesDeleteRole = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiRolesDeleteRoleData, ThrowOnError>): RequestResult<AmsPublicApiRolesDeleteRoleResponses, AmsPublicApiRolesDeleteRoleErrors, ThrowOnError> => (options.client ?? client).delete<AmsPublicApiRolesDeleteRoleResponses, AmsPublicApiRolesDeleteRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/roles/{role_code}',
    ...options
});

/**
 * Update Role
 *
 * Edit a custom role's name, description, and permission set in the caller's own account.
 *
 * `role_code` identifies a resource in the path; the role is looked up only within the caller's bound
 * account, so a code that belongs to another account (or does not exist) returns 404 either way —
 * role existence is not enumerable across accounts (CLAUDE.md "Public API Surface Disclosure").
 * Standard and owner roles are immutable and return 409.
 */
export const amsPublicApiRolesUpdateRole = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiRolesUpdateRoleData, ThrowOnError>): RequestResult<AmsPublicApiRolesUpdateRoleResponses, AmsPublicApiRolesUpdateRoleErrors, ThrowOnError> => (options.client ?? client).patch<AmsPublicApiRolesUpdateRoleResponses, AmsPublicApiRolesUpdateRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/roles/{role_code}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Users
 */
export const amsPublicApiUsersListUsers = <ThrowOnError extends boolean = false>(options?: Options<AmsPublicApiUsersListUsersData, ThrowOnError>): RequestResult<AmsPublicApiUsersListUsersResponses, AmsPublicApiUsersListUsersErrors, ThrowOnError> => (options?.client ?? client).get<AmsPublicApiUsersListUsersResponses, AmsPublicApiUsersListUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users',
    ...options
});

/**
 * Create User
 */
export const amsPublicApiUsersCreateUser = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiUsersCreateUserData, ThrowOnError>): RequestResult<AmsPublicApiUsersCreateUserResponses, AmsPublicApiUsersCreateUserErrors, ThrowOnError> => (options.client ?? client).post<AmsPublicApiUsersCreateUserResponses, AmsPublicApiUsersCreateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get User
 */
export const amsPublicApiUsersGetUser = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiUsersGetUserData, ThrowOnError>): RequestResult<AmsPublicApiUsersGetUserResponses, AmsPublicApiUsersGetUserErrors, ThrowOnError> => (options.client ?? client).get<AmsPublicApiUsersGetUserResponses, AmsPublicApiUsersGetUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{email}',
    ...options
});

/**
 * Edit User
 */
export const amsPublicApiUsersEditUser = <ThrowOnError extends boolean = false>(options: Options<AmsPublicApiUsersEditUserData, ThrowOnError>): RequestResult<AmsPublicApiUsersEditUserResponses, AmsPublicApiUsersEditUserErrors, ThrowOnError> => (options.client ?? client).put<AmsPublicApiUsersEditUserResponses, AmsPublicApiUsersEditUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{email}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
